import { PropertiesRouting } from './properties.routing';

export const Properties = PropertiesRouting;
